<template>
  <div>
    <div v-if="display_information_mineur">Pour les participants de moins de 12 ans, vous pouvez répondre au
      questionnaire
      relatif à l'état de santé du sportif de moins de 12 ans</div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-select :items="items" @update:model-value="onSelectChange" v-model="current_champ.value" ref="field"
      @blur="$refs.field.validate()" :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>

    <DialogFormMineur v-if="display_popup_mineur" :inscription="inscription" @unvalidate="unvalidate_mineur"
      @validate="validate_mineur"></DialogFormMineur>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import DialogFormMineur from "@/components/Inscription/Champs_Formulaire/DialogFormMineur.vue";
export default {
  components: { DialogFormMineur },
  props: ["champ", "inscription", "mode", "is_disable", "in_edit"],
  data() {
    return {
      current_champ: {},
      items: [],
      display_popup_mineur: false,
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        if (this.current_champ.value !== "Questionnaire pour les - 12 ans") {
          this.display_popup_mineur = false;
        }
        this.$forceUpdate();
      },
    },
    "inscription.coureur.champs.date_naissance": {
      deep: true,
      handler() {
        this.render_availables_choices();
      },
    },
  },
  computed: {
    ...mapStores(useMainStore),
    display_information_mineur() {
      let choices = this.current_champ.options.split(";");
      return choices.includes("Questionnaire pour les - 12 ans");
    },
  },
  methods: {
    onSelectChange(value) {
      if (typeof this.change_identity_current_coureur === "function") {
        this.change_identity_current_coureur(this.current_champ.nom);
      }
      if (value === "Questionnaire pour les - 12 ans") {
        this.display_popup_mineur = true;
      } else {
        this.display_popup_mineur = false;
      }
    },

    render_availables_choices() {
      const lock_options_type_document = this.mainStore.module.has_lock_options_type_document;
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (lock_options_type_document) {
        return;
      }
      let choices = this.current_champ.options.split(";");
      if (is_bicentenaire) {
        choices = this.handle_render_questionnaire_mineur(choices);
      }
      choices = this.handle_render_certificat_medical(choices);
      choices = this.handle_render_licence(choices);
      choices = this.handle_render_pps(choices);
      choices = this.handle_not_course_pied(choices);
      choices = this.handle_render_swimrun26(choices);
      choices = this.handle_render_only_licence_ffa(choices);
      choices = this.handle_render_XGTV26(choices);
      this.current_champ.options = choices.join(";");
      const is_ffrp_event = this.mainStore.module.is_ffrp_event;
      this.items = this.$itemsSelect.getSelection(this.current_champ.options, is_ffrp_event);
    },

    handle_not_course_pied(choices) {


      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);
      for (let i = 0; i < selected_courses.length; i++) {
        if (selected_courses[i].metadatas.discipline && selected_courses[i].metadatas.discipline != "Course à pied" && selected_courses[i].metadatas.discipline != "Marche nordique" && selected_courses[i].metadatas.discipline != "Canicross") {
          choices = this.remove_choice(choices, "Pass Prévention Santé");
          choices = this.remove_choice(choices, "Licence FFA");
          choices = this.remove_choice(choices, "Document PPS");
          choices = this.add_choice(choices, "Certificat médical");
          choices = this.add_choice(choices, "Autre licence");
          return choices;
        }
      }

      return choices;
    },

    handle_render_swimrun26(choices) {
      if (this.mainStore.module.base != "SWIMRUN26") {
        return choices;
      }
      choices = this.remove_choice(choices, "Certificat médical");
      choices = this.remove_choice(choices, "Autre licence");
      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);

      for (let i = 0; i < selected_courses.length; i++) {
        if (selected_courses[i].nom.includes("FFSU")) {
          return choices;
        }
      }
      choices = this.add_choice(choices, "Certificat médical");
      return choices;
    },

    handle_render_licence(choices) {
      const disable_licence = this.mainStore.module.has_disable_licence;
      if (disable_licence) {
        choices = this.remove_choice(choices, "Licence");

      }
      return choices;
    },

    handle_render_pps(choices) {
      const date_fin_evenement = this.mainStore.module.evenement.date_fin;
      const is_ffa = this.mainStore.module.is_ffa_module;
      const has_pps = this.mainStore.module.has_pps;
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;

      // Si le module n'est pas FFA ou s'il n'y a pas de PPS, on retire le choix PPS
      if (!is_ffa || !has_pps) {
        choices = this.remove_choice(choices, "Pass Prévention Santé");
        const date_naissance = this.inscription.coureur.champs.date_naissance.value;
        if (is_bicentenaire && this.$moment(date_naissance).isValid() && this.$moment(date_fin_evenement).diff(date_naissance, "years") < 12) {
          choices = this.remove_choice(choices, "Document PPS");
        }
        return choices;
      }

      // Si le participant est de moins de 12 ans, on retire le choix PPS
      const date_naissance = this.inscription.coureur.champs.date_naissance.value;
      if (is_bicentenaire && this.$moment(date_naissance).isValid() && this.$moment(date_fin_evenement).diff(date_naissance, "years") < 12) {
        choices = this.remove_choice(choices, "Pass Prévention Santé");
        choices = this.remove_choice(choices, "Document PPS");
        return choices;
      }



      // Si le participant est majeur et qu'il n'y a que des courses à pied
      choices = this.add_choice(choices, "Licence FFA");
      choices = this.add_choice(choices, "Pass Prévention Santé");
      return choices;
    },

    // Render questionnaire mineur, si participant est mineur et si course est course à pied
    handle_render_questionnaire_mineur(choices) {
      const questionnaire_label = "Questionnaire pour les - 12 ans";
      const default_value = "Sélectionnez le type de document";
      const was_selected = this.current_champ.value === questionnaire_label;

      if (choices.includes(questionnaire_label)) {
        choices = choices.filter((choice) => choice !== questionnaire_label);
      }

      const date_naissance = this.inscription.coureur.champs.date_naissance.value;
      const is_date_invalid = !this.$moment(date_naissance).isValid()
        || this.$moment(date_naissance).year() <= 1900
        || this.$moment(date_naissance).year() > this.$moment().year()
        || this.$moment().diff(date_naissance, "years") >= 12;

      if (is_date_invalid) {
        if (was_selected) {
          this.current_champ.value = default_value;
        }
        return choices;
      }

      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);
      for (let i = 0; i < selected_courses.length; i++) {
        if (
          !selected_courses[i].metadatas.discipline ||
          (selected_courses[i].metadatas.discipline != "Course à pied" && selected_courses[i].metadatas.discipline != "Marche nordique") ||
          this.$moment(selected_courses[i].date_depart).diff(date_naissance, "years") >= 12
        ) {
          if (was_selected) {
            this.current_champ.value = default_value;
          }
          return choices;
        }
      }

      // Si le participant est de moins de 12 ans et qu'il n'y a que des courses à pied
      choices.push(questionnaire_label);
      if (was_selected) {
        this.current_champ.value = questionnaire_label;
      }
      return choices;
    },

    handle_render_XGTV26(choices) {
      if (this.mainStore.module.base != "VVX26") {
        return choices;
      }

      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);
      const course = this.inscription.course ? this.inscription.course : selected_courses[0];

      if (!course) {
        return choices;
      }

      const is_xgtv = course.id == 1353 || course.id == 1354 || course.id == 1362;
      if (!is_xgtv) {
        return choices;
      }
      choices = this.remove_choice(choices, "Pass Prévention Santé");
      choices = this.remove_choice(choices, "Document PPS");
      choices = this.remove_choice(choices, "Licence FFA");
      choices = this.remove_choice(choices, "Certificat médical");
      choices = this.remove_choice(choices, "Autre licence");
      choices = this.add_choice(choices, "Licence FFCO");
      choices = this.add_choice(choices, "Non licencié FFCO");



      return choices;
    },

    handle_render_only_licence_ffa(choices) {
      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);
      for (let i = 0; i < selected_courses.length; i++) {
        if (selected_courses[i].metadatas.only_licence_ffa && selected_courses[i].metadatas.only_licence_ffa == "1") {

          choices = this.remove_choice(choices, "Pass Prévention Santé");
          choices = this.remove_choice(choices, "Document PPS");
          choices = this.remove_choice(choices, "Certificat médical");
          choices = this.remove_choice(choices, "Autre licence");
          choices = this.remove_choice(choices, "Questionnaire pour les - 12 ans");


          choices = this.add_choice(choices, "Licence FFA");
          return choices;

        }
      }
      return choices;
    },

    // Si le participant est de moins de 12 ans ou si la course est avant le 1er Septembre 2024
    handle_render_certificat_medical(choices) {

      choices = this.remove_choice(choices, "Certificat médical");
      const is_ffa = this.mainStore.module.is_ffa_module;
      const replace_cm_by_pps = this.mainStore.module.replace_cm_by_pps;
      const retirer_cm = this.mainStore.module.retirer_cm;
      // Si le module n'est pas FFA ou si le certificat médical est remplacé par le PPS, on retire le choix CM
      if (!is_ffa && !replace_cm_by_pps && !retirer_cm) {
        choices = this.add_choice(choices, "Certificat médical");

      }
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      const date_naissance = this.inscription.coureur.champs.date_naissance.value;
      const date_fin_evenement = this.mainStore.module.evenement.date_fin;
      if (is_bicentenaire && this.$moment(date_naissance).isValid() && this.$moment(date_fin_evenement).diff(date_naissance, "years") < 12) {
        choices = this.add_choice(choices, "Certificat médical");
      }


      return choices;
    },

    remove_choice(choices, choice_to_remove) {
      if (choices.includes(choice_to_remove)) {
        choices = choices.filter((choice) => choice != choice_to_remove);
      }
      if (this.current_champ.value == choice_to_remove) {
        this.current_champ.value = "Sélectionnez le type de document";
      }
      return choices;
    },

    add_choice(choices, choice_to_add) {

      if (!choices.includes(choice_to_add)) {
        choices.push(choice_to_add);
      }
      return choices;
    },

    /* ------------------------ */
    validate_mineur() {
      this.$emit("validate_mineur");
      this.display_popup_mineur = false;
    },
    unvalidate_mineur() {
      this.display_popup_mineur = false;
      this.current_champ.value = "Sélectionnez le type de document";
    },

    populateSelect() {
      this.items = this.$itemsSelect.getSelection(this.current_champ.options);
    },
    handle_case_mineur() {
      let date_naissance = this.inscription.coureur.champs.date_naissance.value;
      if (this.$moment(date_naissance).isValid() == false || this.$moment(date_naissance).year() < 1900 || this.$moment(date_naissance).year() > this.$moment().year()) {
        this.remove_questionnaire_mineur();
        return;
      }
      if (this.$moment().diff(date_naissance, "years") >= 12) {
        this.remove_questionnaire_mineur();
        return;
      }

      let selected_courses = this.inscription.list_courses.list.filter((course) => course.selected);
      for (let i = 0; i < selected_courses.length; i++) {
        if (selected_courses[i].metadatas.discipline &&
          (selected_courses[i].metadatas.discipline == "Course à pied" || selected_courses[i].metadatas.discipline != "Marche nordique")
          && this.$moment(selected_courses[i].date_depart).diff(date_naissance, "years") < 12) {
          this.add_questionnaire_mineur();
        } else {
          this.remove_questionnaire_mineur();
        }
      }
    },
    remove_questionnaire_mineur() {
      this.display_information_mineur = false;
      let choices = this.current_champ.options.split(";");
      if (this.current_champ.value == "Questionnaire pour les - 12 ans") {
        this.current_champ.value = "Sélectionnez le type de document";
      }
      if (choices.includes("Questionnaire pour les - 12 ans")) {
        choices = choices.filter((choice) => choice != "Questionnaire pour les - 12 ans");
        this.current_champ.options = choices.join(";");
        this.populateSelect();
      }
    },
    add_questionnaire_mineur() {
      this.display_information_mineur = true;
      let choices = this.current_champ.options.split(";");
      if (!choices.includes("Questionnaire pour les - 12 ans")) {
        choices.push("Questionnaire pour les - 12 ans");
        this.current_champ.options = choices.join(";");
        this.populateSelect();
      }
    },
  },
  created() {
    this.current_champ = this.champ;
    this.populateSelect();
    this.render_availables_choices();
  },
};
</script>

<style lang="scss">
.v-autocomplete__content {
  max-height: 300px !important;
  min-height: auto !important;
}
</style>